//----------------------------------------------------------------------------------
//Footer Newsletter Redirect
//----------------------------------------------------------------------------------

var form;

$(document).ready(function(){
  form = document.getElementsByClassName("banner banner--success text-start");
  console.log(form);
  if(form.length > 0 && form[0].innerHTML.startsWith("You have been subscribed to our newsletter"))
    window.location = '/pages/thank-you-for-signing-up';
});


//----------------------------------------------------------------------------------
//Variant Change Description Dropdowns Update
//----------------------------------------------------------------------------------

document.addEventListener('variant:change', function(event) {
    const variantHandle = event.detail.variant; // Gives you access to the whole variant details
    const descs = jQuery.parseJSON($("#hidden-variant-metafields-container-description").html());
    const ingrs = jQuery.parseJSON($("#hidden-variant-metafields-container-ingredients").html());
    const notes = jQuery.parseJSON($("#hidden-variant-metafields-container-notes").html());
    console.log(ingrs);
    const descriptions = JSON.parse(descs);
    const how_to = JSON.parse(notes);
    const ingredients = JSON.parse(ingrs);
    descriptions["descriptions"].forEach(function(desc) {
      if (desc.variant_id == variantHandle.id) {
          $(".product-info__block-item[data-block-id|='description'] .prose").first().html(desc.metafield_value);
      }
    });  
    how_to["notes"].forEach(function(note) {
      if (note.variant_id == variantHandle.id) {
          $(".accordion__content").eq(1).html(note.metafield_value);
      }
    });
    ingredients["ingredients"].forEach(function(ing) {
      if (ing.variant_id == variantHandle.id) {
          $(".accordion__content").eq(0).html(ing.metafield_value);
      }
    });
    
});